import {
  IonCard,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import {
  addCircle,
  bagCheck,
  removeCircle,
  trashOutline,
} from "ionicons/icons";
import { useCart } from "./useCart";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import SubHeader from "../FrameAndEasel/SubHeader";
import { usePictures } from "../Pictures/usePictures";

const BrandedBag = () => {
  const { brandedBag, changeBrandedBagNumber } = useCart();

  const { equipmentPrice, equipmentState } = usePictures();
  const disabled = !equipmentState.brandedBag;
  const allowRemove = brandedBag > 0;

  return (
    <IonCard style={{ margin: "3px", padding: "13px 16px 0 16px" }}>
      <SubHeader
        icon={bagCheck}
        text="Brendirana kesa"
        onTop
        disabled={disabled}
      >
        <NumberMoney value={equipmentPrice.brandedBag} />
      </SubHeader>
      <IonLabel className="center">
        Kesa je predviđena za proizvode koji nisu montirani na blid ramu
      </IonLabel>

      {!disabled && (
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-right">
              {brandedBag > 0 && (
                <IonIcon
                  className={allowRemove ? "cursorP" : "op5"}
                  icon={brandedBag === 1 ? trashOutline : removeCircle}
                  size="large"
                  color={allowRemove ? "primary" : "var(--ion-color-light)"}
                  onClick={() => {
                    if (allowRemove) {
                      changeBrandedBagNumber(brandedBag - 1);
                    }
                  }}
                />
              )}
            </IonCol>
            <IonCol className="ion-text-center f20 b" style={{ paddingTop: 7 }}>
              <IonLabel>{brandedBag}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                className="cursorP"
                color="primary"
                icon={addCircle}
                size="large"
                onClick={() => changeBrandedBagNumber(brandedBag + 1)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
      {disabled && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>Trenutno nema na stanju</IonLabel>
        </div>
      )}
    </IonCard>
  );
};

export default BrandedBag;
